<div class="user-menu" role="menu" [attr.aria-label]="'userMenu.ariaLabel' | translate">
  @if (showHead()) {
    <div class="user-menu__head">
      @if (loadedProfile(); as profile) {
        <span class="user-menu__avatar" aria-hidden="true">
          <app-avatar [name]="profile.displayName" [size]="44" [benutzerId]="profile.id" />
        </span>
        <div class="user-menu__text">
          <div class="user-menu__name" [title]="profile.displayName">{{ profile.displayName }}</div>
          <div class="user-menu__email" [title]="profile.email">{{ profile.email }}</div>
          <div class="user-menu__role">
            {{ tenantRoleKey() | translate }}
            @if (projectRoleKey(); as projectRole) {
              <span>· {{ projectRole | translate }}</span>
            }
          </div>
        </div>
      }
    </div>
  }
  @for (entry of entries(); track entry.path) {
    <button
      type="button"
      role="menuitem"
      tabindex="-1"
      class="user-menu__item"
      [class.user-menu__item--active]="isActive(entry.path)"
      [attr.data-testid]="entry.testId"
      (click)="select(entry.path)"
      (keydown)="onMenuKeydown($event)"
    >
      <span class="user-menu__icon" aria-hidden="true">
        @if (entry.icon === 'account') {
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="8.5" r="3.6" stroke="currentColor" stroke-width="1.7" />
            <path
              d="M5 19.5c.8-3.4 3.6-5.3 7-5.3s6.2 1.9 7 5.3"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
        } @else {
          <mat-icon class="user-menu__mat-icon">settings</mat-icon>
        }
      </span>
      <span class="user-menu__label">{{ entry.labelKey | translate }}</span>
    </button>
  }
  <div class="user-menu__signout-block">
    <button
      type="button"
      role="menuitem"
      tabindex="-1"
      class="user-menu__signout"
      data-testid="usermenu-abmelden"
      (click)="select('/logout')"
      (keydown)="onMenuKeydown($event)"
    >
      <span class="user-menu__arrow" aria-hidden="true">↗</span>
      <span class="user-menu__label">{{ 'userMenu.logout' | translate }}</span>
    </button>
  </div>
</div>
